import { openDB } from "idb";

const DB_NAME = "amalvbc-offline";
const DB_VERSION = 1;

export const STORE_READ_CACHE = "read_cache";
export const STORE_WRITE_QUEUE = "write_queue";
export const STORE_CONFLICTS = "conflicts";

let _dbPromise = null;

export function db() {
  if (!_dbPromise) {
    _dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(d) {
        if (!d.objectStoreNames.contains(STORE_READ_CACHE)) {
          d.createObjectStore(STORE_READ_CACHE, { keyPath: "key" });
        }
        if (!d.objectStoreNames.contains(STORE_WRITE_QUEUE)) {
          const s = d.createObjectStore(STORE_WRITE_QUEUE, { keyPath: "id", autoIncrement: true });
          s.createIndex("createdAt", "createdAt");
        }
        if (!d.objectStoreNames.contains(STORE_CONFLICTS)) {
          d.createObjectStore(STORE_CONFLICTS, { keyPath: "id", autoIncrement: true });
        }
      },
    });
  }
  return _dbPromise;
}

// ----- Read cache (key = "METHOD url") -----
export async function cacheRead(key, data) {
  const d = await db();
  await d.put(STORE_READ_CACHE, { key, data, ts: Date.now() });
}

export async function getCachedRead(key) {
  const d = await db();
  return (await d.get(STORE_READ_CACHE, key))?.data;
}

export async function clearReadCacheForPath(pathPrefix) {
  const d = await db();
  const tx = d.transaction(STORE_READ_CACHE, "readwrite");
  let cur = await tx.store.openCursor();
  while (cur) {
    if (cur.value.key.includes(pathPrefix)) await cur.delete();
    cur = await cur.continue();
  }
  await tx.done;
}

// ----- Write queue -----
export async function enqueueWrite(op) {
  const d = await db();
  const id = await d.add(STORE_WRITE_QUEUE, {
    ...op,
    createdAt: Date.now(),
    attempts: 0,
  });
  return id;
}

export async function listQueue() {
  const d = await db();
  return await d.getAllFromIndex(STORE_WRITE_QUEUE, "createdAt");
}

export async function removeFromQueue(id) {
  const d = await db();
  await d.delete(STORE_WRITE_QUEUE, id);
}

export async function updateQueueItem(id, patch) {
  const d = await db();
  const item = await d.get(STORE_WRITE_QUEUE, id);
  if (item) await d.put(STORE_WRITE_QUEUE, { ...item, ...patch });
}

export async function queueCount() {
  const d = await db();
  return await d.count(STORE_WRITE_QUEUE);
}

// ----- Conflicts -----
export async function addConflict(c) {
  const d = await db();
  await d.add(STORE_CONFLICTS, { ...c, ts: Date.now(), resolved: false });
}

export async function listConflicts() {
  const d = await db();
  const all = await d.getAll(STORE_CONFLICTS);
  return all.filter((c) => !c.resolved);
}

export async function resolveConflict(id) {
  const d = await db();
  const c = await d.get(STORE_CONFLICTS, id);
  if (c) await d.put(STORE_CONFLICTS, { ...c, resolved: true });
}
